// @ts-nocheck
import { AbstractURLMessage } from "./AbstractURLMessage";

export class URLMessage extends AbstractURLMessage {
  constructor() {
    super();
  }
}
